import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  competencyTemplateKeys,
  competencyTemplateMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/competencyTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateCompetencyTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateCompetencyTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...competencyTemplateMutationKeys.updateTemplate,
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: competencyTemplateKeys._def })
      options?.onSuccess?.(...args)
    },
  })
}
